// 디자인 미리보기(designPreview.files) 층 분류 — StlViewer 배열 보기의 토글·재질·로딩 순서 기준 (2026-10-15 대표 지시
// "스캔 상악·하악도 보이게, 상악·하악·크라운·커스텀 어버트먼트를 각각 껐다 켰다").
// 에이전트(dentcluster-agent-v2/electron/lab/design-preview.js)가 올리는 files[] 항목: { layer, part, kind, ... }
//   layer 'crown'(보철 — crown·bridge·inlay 등) | 'abutment' | 'scan'(part 'upper'|'lower'|'scanbody-upper'|'scanbody-lower'|'scanbody-x')
//   | 'model'(part 'base'|'die')

/** 화면 토글 순서·이름. 대표 지정 4개(상악·하악·크라운·커스텀 어버트먼트) 먼저, 그다음 스캔바디·모델·다이 */
export const PREVIEW_LAYERS = [
    { key: 'upper', label: '상악' },
    { key: 'lower', label: '하악' },
    { key: 'crown', label: '크라운' },
    { key: 'abutment', label: '커스텀 어버트먼트' },
    { key: 'scanbody', label: '스캔바디' },
    { key: 'model', label: '모델' },
    { key: 'die', label: '다이' },
    { key: 'scan', label: '스캔(기타)' },   // part를 알 수 없는 스캔 — 정상 업로드에선 나오지 않음(안전망)
];

/** 기본 보이기 — 전부 켬. 모델·다이도 켬(2026-10-01 대표 확정 유지) */
export const DEFAULT_LAYER_VISIBILITY = PREVIEW_LAYERS.reduce((acc, l) => { acc[l.key] = true; return acc; }, {});

const KNOWN = new Set(PREVIEW_LAYERS.map(l => l.key));

/** files[] 항목 → 토글 키. layer 없음(구버전)·모르는 값은 'crown'(kind가 abutment면 'abutment') */
export function previewLayerKey(entry) {
    const layer = String(entry?.layer || '').toLowerCase();
    const part = String(entry?.part || '').toLowerCase();
    if (layer === 'scan') {
        if (part === 'upper') return 'upper';
        if (part === 'lower') return 'lower';
        if (part.startsWith('scanbody')) return 'scanbody';
        return 'scan';
    }
    if (layer === 'model') return part === 'die' ? 'die' : 'model';
    if (layer === 'abutment') return 'abutment';
    if (layer && KNOWN.has(layer)) return layer;
    if (String(entry?.kind || '').toLowerCase() === 'abutment') return 'abutment';
    return 'crown';
}

/** 스캔 계열(회전 중심 계산 제외) */
export const isScanLayerKey = (key) => key === 'upper' || key === 'lower' || key === 'scanbody' || key === 'scan';
/** 회전 중심·먼저 불러올 층 (보철물) */
export const isFocusLayerKey = (key) => key === 'crown' || key === 'abutment';

/** 불러오는 순서: 보철 → 스캔바디 → 상·하악 스캔 → 모델(큰 파일은 뒤로) */
const LOAD_RANK = { crown: 0, abutment: 0, scanbody: 1, upper: 2, lower: 2, scan: 2, model: 3, die: 3 };
export const loadRankOf = (key) => (LOAD_RANK[key] ?? 9);

/** 층별 파일 수 집계 — { key: total } (그 케이스에 없는 층은 키가 없다 → 토글 숨김) */
export function countLayers(entries) {
    const out = {};
    (Array.isArray(entries) ? entries : []).forEach(en => {
        if (!en) return;
        const k = previewLayerKey(en);
        out[k] = (out[k] || 0) + 1;
    });
    return out;
}
